import { LanguageMode, ToolbarType } from '@i18nspect/types';
// import numberState from './number';
import { isEnumInclude } from '../utils';
var _toolbar = null;
var validateToolbar = function (parsed) {
    if (!parsed)
        throw new Error();
    if (!isEnumInclude(ToolbarType, parsed.type))
        throw new Error('Invalid type');
    if (parsed.type === ToolbarType.Language) {
        if (parsed.mode != null && !isEnumInclude(LanguageMode, parsed.mode)) {
            throw new Error('Invalid language mode');
        }
    }
    return parsed;
};
(function () {
    var _a, _b, _c;
    try {
        var parsed = JSON.parse((_a = window.localStorage.getItem('__I18NSPECT_DEBUG__')) !== null && _a !== void 0 ? _a : 'null') ||
            // If using garfish (garfish intercepts window.localStorage implementation for sub-apps)
            JSON.parse((_c = (_b = window.localStorage.rawStorage) === null || _b === void 0 ? void 0 : _b.getItem('__I18NSPECT_DEBUG__')) !== null && _c !== void 0 ? _c : 'null');
        if (!parsed || !parsed.type)
            return;
        _toolbar = validateToolbar(parsed);
        // switch (_toolbar.type) {
        //   case ToolbarType.Number:
        //     numberState.languageList = _toolbar.namespace.languages;
        //     break;
        // }
    }
    catch (e) {
        console.error(e);
    }
})();
var subscribers = new Set();
export var subscribe = function (callback) {
    subscribers.add(callback);
    return function () { return subscribers.delete(callback); };
};
export var notifySubscribers = function () {
    subscribers.forEach(function (func) { return func(); });
};
export var getToolbar = function () { return _toolbar; };
export var getToolbarType = function () { return _toolbar === null || _toolbar === void 0 ? void 0 : _toolbar.type; };
